
export async function returnPublicKeys(url) {
    const response = await fetch(url);
    const responseJson = await response.json();
    return responseJson.keys;
}

export async function getMatchingKey(publicKeys, kid) {
    for (const key of publicKeys) {
        if (key.kid === kid) {
            return key;
        }
    }
}

export function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export async function decode(tokenComponent) {

    const cleanedPayload = tokenComponent.replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = Buffer.from(cleanedPayload, 'base64').toString('utf-8');

    const uriEncodedPayload = Array.from(decodedPayload).reduce((acc, char) => {
        const uriEncodedChar = ('00' + char.charCodeAt(0).toString(16)).slice(-2)
        return `${acc}%${uriEncodedChar}`
    }, '')
    const jsonPayload = decodeURIComponent(uriEncodedPayload);
    return JSON.parse(jsonPayload);
}

export async function verifyToken(bearerToken, matchedKey, payload) {
    const certificate = matchedKey.x5c[0];
    const publicKey = `-----BEGIN CERTIFICATE-----\n${certificate}\n-----END CERTIFICATE-----`;
    let verifiedToken
    try {
        verifiedToken = verifyJwtWithoutLibrary(bearerToken, publicKey);
    } catch (error) {
        console.log(error);
        return false;
    }
    return verifyRoles(verifiedToken.roles);
}
export function verifyJwtWithoutLibrary(token, publicKeyPem) {
    // Split the JWT into parts
    const [headerB64, payloadB64, signatureB64] = token.split('.');

    // Reconstruct the signing input
    const signingInput = `${headerB64}.${payloadB64}`;

    // Decode the signature from base64url
    const signature = Uint8Array.from(atob(signatureB64.replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0));

    // Import the public key
    return window.crypto.subtle.importKey(
        'spki',
        pemToArrayBuffer(publicKeyPem),
        {
            name: 'RSASSA-PKCS1-v1_5',
            hash: { name: 'SHA-256' }
        },
        false,
        ['verify']
    ).then(publicKey =>
        window.crypto.subtle.verify(
            'RSASSA-PKCS1-v1_5',
            publicKey,
            signature,
            new TextEncoder().encode(signingInput)
        )
    );
}

// Helper to convert PEM to ArrayBuffer
function pemToArrayBuffer(pem) {
    const b64Lines = pem.replace(/-----[^-]+-----/g, '').replace(/\s+/g, '');
    const bStr = atob(b64Lines);
    const bytes = new Uint8Array(bStr.length);
    for (let i = 0; i < bStr.length; i++) {
        bytes[i] = bStr.charCodeAt(i);
    }
    return bytes.buffer;
}
export async function verifyRoles(roles, roleToCheck) {
   
    let hasRole = false;

    if(roles !== undefined && roles !== null) {
        if (roles.includes(roleToCheck)) {
            hasRole = true
        }
    } 
    return hasRole;
}

export function getBaseUrl() {
    if (isEnv("dev")) {
        return "https://api.finpro.dev.principal.com";
    }
    if (isEnv("staging")) {
        return "https://api.finpro.staging.principal.com";
    }
    if (isEnv("d34hc99os1f0q")) {
        return "https://api.finpro.staging.principal.com";
    }
    if (isEnv("local")) {
        return "https://api.finpro.staging.principal.com";
    }
    return "https://api.finpro.principal.com";
}

function isEnv(env) {
    return window.location.host.includes(env);
}